/**
 * Managing Your Pipeline Tour
 *
 * Walks users through the entity management and pipeline views.
 * Shows how to create entities and navigate the data tables.
 */

import type { TourConfig } from './tour-config.types';

export const pipelineTour: TourConfig = {
  id: 'managing-pipeline',
  title: 'tours.pipeline.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="entities-new-entity-btn"]',
      content: 'tours.pipeline.steps.createEntity',
      placement: 'bottom',
      route: '/entities',
    },
    {
      target: '[data-astor-id="entities-data-table"]',
      content: 'tours.pipeline.steps.entitiesTable',
      placement: 'top',
      route: '/entities',
    },
    {
      target: '[data-astor-id="cases-data-table"]',
      content: 'tours.pipeline.steps.trackCases',
      placement: 'top',
      route: '/loans',
    },
  ],
};
